import type { SugerenciaPublic } from '@app/shared';

import { api } from '../../../lib/api';

export const sugerenciasApi = {
  async calificar(id: string, calificacion: number): Promise<{ sugerencia: SugerenciaPublic }> {
    const { data } = await api.post<{ sugerencia: SugerenciaPublic }>(`/sugerencias/${id}/calificar`, {
      calificacion,
    });
    return data;
  },
  // Botón "generar ahora" (29/09/2026): la respuesta llega por SSE, no por acá.
  async generarAhora(leadId: string): Promise<void> {
    await api.post(`/sugerencias/lead/${leadId}/generar-ahora`);
  },
};
